import React, { forwardRef } from 'react'
import { Input } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type AntdFormInputProps = React.ComponentProps<typeof Input> & {
  //
} & AntdFormItemProps

type TextInputProps = Omit<React.ComponentProps<typeof Input>, 'onChange'> & {
  value?: string
  onChange?: (value: string) => void
}

export const TextInput: React.FC<TextInputProps> = ({ onChange, ...props }) => {
  return <Input {...props} onChange={e => onChange!(e.target.value)} />
}

export const AntdFormInput: React.FC<AntdFormInputProps> = forwardRef(({
  fieldProps,
  className,
  ...props
}, ref) => {
  return (
    <AntdFormItem {...fieldProps}>
      <Input allowClear {...props} ref={ref} className={cn('w-full', className)} />
    </AntdFormItem>
  )
})

type AntdFormInputPasswordProps = React.ComponentProps<typeof Input.Password> & {
  //
} & AntdFormItemProps

export const AntdFormPassword: React.FC<AntdFormInputPasswordProps> = forwardRef(({
  fieldProps,
  className,
  ...props
}, ref) => {
  return (
    <AntdFormItem {...fieldProps}>
      <Input.Password {...props} ref={ref} className={cn('w-full', className)} />
    </AntdFormItem>
  )
})